import NestedRouteComponent from 'router/nestedViews/NestedRouteComponent';
import asyncLoadView from 'utils/asyncLoadView/asyncLoadView';
import routeArgsToInt from 'router/utils/routeArgsToInt';
import translation from 'translation';

const projectStatisticsRoutes = [
  {
    path: 'statistics',
    component: NestedRouteComponent,
    meta: {
      permissions: ['READ_PROJECT_STATISTICS']
    },
    children: [
      {
        path: '',
        name: 'projectStatistics',
        meta: {
          routeName: {
            segmentName: () => translation.tr('Placements statistics')
          }
        },
        component: () => asyncLoadView(import('pages/statistics/StatisticsPage')),
        props: routeArgsToInt
      },
      {
        path: 'detailed',
        name: 'projectDetailedStatistics',
        redirect: {name: 'projectStatistics'}
      }
    ]
  }
];

export default projectStatisticsRoutes;
